/**
 * The pull station's advisory stamps (pulled-blanks v2 §2.3, D6 / D18): the pull list printed, the labels
 * printed, the pull station opened. Server-side `if_not_exists` — first time only — and NEVER a gate or a
 * record: they decide which sheets a shelf count may still ask about, never the arithmetic. Fail-open by
 * design: a stamp that fails must never block a print or the rows, so this swallows every outcome.
 */
import type { ApiClient } from '@/lib/api/client';
import type { PullStampKind } from './batch-lib';

export async function stampPull(
  client: Pick<ApiClient, 'POST'>,
  batchId: string,
  kind: PullStampKind,
): Promise<void> {
  try {
    await client.POST('/batches/{batchId}/pull-stamp', {
      params: { path: { batchId } },
      body: { kind },
    });
  } catch {
    // A network failure here is not the puller's problem — the print and the rows go on.
  }
}
